/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Link_BlogInputs */

const en_home_footer_link_blog = /** @type {(inputs: Home_Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const fr_home_footer_link_blog = /** @type {(inputs: Home_Footer_Link_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogue`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Home_Footer_Link_BlogInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_link_blog = /** @type {((inputs?: Home_Footer_Link_BlogInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Link_BlogInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_link_blog(inputs)
	return fr_home_footer_link_blog(inputs)
});